import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15 8h1v8","key":"svg-0"}],["path",{"d":"M7 8h2.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-2.5","key":"svg-1"}]]

const IconNumber31Small = createReactComponent('outline', 'number-31-small', 'Number31Small', __iconNode);

export default IconNumber31Small;